import * as yup from 'yup';

function productLineName(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'PRODUCT_LINE_NAME_IS_REQUIRED',
        defaultMessage: 'Product Line Name is required',
      }),
    )
    .max(
      64,
      formatMessage({
        id: 'EDITFORM_PRODUCTLINENAME_FIELD_MAX_CHARS_64',
        defaultMessage: 'Product Line Name should be less than 64 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'STATUS_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      productLineName: productLineName(formatMessage),
      status: status(formatMessage),
    })
    .required();

export default validationSchema;
